// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.createOrden_tempura__011hn {
  background-color: "blue";
}

.createOrden_tempura__011hn ul {
  padding: 0px;
}

.createOrden_tempura__011hn input[type="text"] {
  padding-right: 0px !important;
  background-color: transparent;
}

.createOrden_tablecenter__nDlFy {
  vertical-align: middle;
}
/*
.nav_container nav {
  display: flex;
  padding: 0px;
  background: #6dd3d6;
}
.nav_container ul {
  /* for example *
  list-style: none;
}

.nav_container li {
  /* for example *
  font-size: large;
}
*/
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/Ventas/createOrden.module.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;AACA;;;;;;;;;;;;;;;CAeC","sourcesContent":[".tempura {\n  background-color: \"blue\";\n}\n\n.tempura ul {\n  padding: 0px;\n}\n\n.tempura input[type=\"text\"] {\n  padding-right: 0px !important;\n  background-color: transparent;\n}\n\n.tablecenter {\n  vertical-align: middle;\n}\n/*\n.nav_container nav {\n  display: flex;\n  padding: 0px;\n  background: #6dd3d6;\n}\n.nav_container ul {\n  /* for example *\n  list-style: none;\n}\n\n.nav_container li {\n  /* for example *\n  font-size: large;\n}\n*/\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tempura": `createOrden_tempura__011hn`,
	"tablecenter": `createOrden_tablecenter__nDlFy`
};
export default ___CSS_LOADER_EXPORT___;
